module.exports = __webpack_public_path__ + "media/5.8fa30295.mp3";